import { render } from "./RevenueLastThreeYears.vue?vue&type=template&id=3a712b26&scoped=true"
import script from "./RevenueLastThreeYears.vue?vue&type=script&lang=js"
export * from "./RevenueLastThreeYears.vue?vue&type=script&lang=js"

import "./RevenueLastThreeYears.vue?vue&type=style&index=0&id=3a712b26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a712b26"]])

export default __exports__